'use client';

import { useSyncExternalStore } from 'react';

export const SIDEBAR_RAIL_QUERY = '(max-width: 1279px)';
const subscribe = (notify: () => void) => {
  const media = window.matchMedia?.(SIDEBAR_RAIL_QUERY);
  media?.addEventListener('change', notify);
  return () => media?.removeEventListener('change', notify);
};
const getSnapshot = () => window.matchMedia?.(SIDEBAR_RAIL_QUERY).matches ?? false;
const getServerSnapshot = () => false;

/** A saved choice wins at every width; only an unset preference follows the viewport. */
export function useSidebarCollapsed(preference: boolean | null | undefined) {
  const narrow = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
  return preference ?? narrow;
}
